export const CONTINUE_TARGET = 'continue';

export const CONTINUE_RULES_DIR = '.continue/rules';
export const CONTINUE_PROMPTS_DIR = '.continue/prompts';
export const CONTINUE_MCP_DIR = '.continue/mcpServers';
export const CONTINUE_MCP_FILE = `${CONTINUE_MCP_DIR}/agentsmesh.json`;
/** Generated main rule file (canonical root remains `.agentsmesh/rules/_root.md`). */
export const CONTINUE_ROOT_RULE = `${CONTINUE_RULES_DIR}/general.md`;
export const CONTINUE_ROOT_RULE_LEGACY = `${CONTINUE_RULES_DIR}/_root.md`;
export const CONTINUE_SKILLS_DIR = '.continue/skills';

export const CONTINUE_GLOBAL_AGENTS_MD = '.continue/AGENTS.md';
export const CONTINUE_GLOBAL_CONFIG = '.continue/config.yaml';

export const CONTINUE_CANONICAL_RULES_DIR = '.agentsmesh/rules';
export const CONTINUE_CANONICAL_COMMANDS_DIR = '.agentsmesh/commands';
export const CONTINUE_CANONICAL_MCP = '.agentsmesh/mcp.json';
